import clsx$1 from "clsx";
import { V as spread_attributes, W as clsx, P as pop, N as push, Q as attr_class, a1 as attr, a3 as element, a4 as ensure_array_like, T as stringify, _ as escape_html } from "./index.js";
import { g as getTheme, i as card, j as heading } from "./theme.js";
import { e as events } from "./events.js";
function Card($$payload, $$props) {
  push();
  let {
    children,
    color = "gray",
    horizontal = false,
    shadow = "md",
    reverse = false,
    img,
    size = "sm",
    class: className,
    classes,
    imgClass,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const styling = classes ?? { image: imgClass };
  const theme = getTheme("card");
  const { base, image } = card({
    size,
    color,
    shadow,
    horizontal,
    reverse,
    href: !!restProps.href
  });
  function childSlot($$payload2) {
    if (img) {
      $$payload2.out += "<!--[-->";
      $$payload2.out += `<img${attr_class(clsx(image({ class: clsx$1(theme?.image, styling.image) })))}${attr("src", img)} alt="" loading="lazy" onerror="this.__e=event"/> `;
      children?.($$payload2);
      $$payload2.out += `<!---->`;
    } else {
      $$payload2.out += "<!--[!-->";
      children?.($$payload2);
      $$payload2.out += `<!---->`;
    }
    $$payload2.out += `<!--]-->`;
  }
  if (restProps.href === void 0) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div${spread_attributes(
      {
        ...restProps,
        class: clsx(base({ class: clsx$1(theme?.base, className) }))
      },
      null
    )}>`;
    childSlot($$payload);
    $$payload.out += `<!----></div>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<a${spread_attributes(
      {
        ...restProps,
        class: clsx(base({ class: clsx$1(theme?.base, className) }))
      },
      null
    )}>`;
    childSlot($$payload);
    $$payload.out += `<!----></a>`;
  }
  $$payload.out += `<!--]-->`;
  pop();
}
function Heading($$payload, $$props) {
  push();
  let {
    children,
    tag = "h1",
    class: className,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("heading");
  let headingCls = heading({ tag, class: clsx$1(theme, className) });
  element(
    $$payload,
    tag,
    () => {
      $$payload.out += `${spread_attributes({ ...restProps, class: clsx(headingCls) }, null)}`;
    },
    () => {
      children($$payload);
      $$payload.out += `<!---->`;
    }
  );
  pop();
}
function SocialMediaIcons($$payload) {
  $$payload.out += `<div class="social-media-container svelte-1ut6jgm"><div class="social-media-link svelte-1ut6jgm"><a href="https://www.facebook.com/officialartisanfairs/" target="_blank" rel="noopener noreferrer"><img src="/media/branding/facebook/facebook-500x500.png" alt="Facebook Logo - Official Artisan Fairs" style="box-shadow: 0 4px 24px rgba(0,0,0,0.12); border-radius: 100%; width: 3em; height: 3em; background-color: #f8f8f6;"/></a></div> <div class="social-media-link svelte-1ut6jgm"><a href="https://www.instagram.com/official_artisanfairs/" target="_blank" rel="noopener noreferrer"><img src="/media/branding/instagram/instagram-500x500.png" alt="Instagram Logo - Official Artisan Fairs" style="box-shadow: 0 4px 24px rgba(0,0,0,0.12); border-radius: 1rem; width: 3em; height: 3em; background-color: #f8f8f6;"/></a></div> <div class="social-media-link svelte-1ut6jgm"><a href="https://www.yelp.com/biz/riverwalk-artisan-fair-bakersfield" target="_blank" rel="noopener noreferrer"><img src="/media/branding/yelp/yelp-transparent-full.webp" alt="Yelp Logo - Official Artisan Fairs" style="box-shadow: 0 4px 24px rgba(0,0,0,0.12); border-radius: 100%; width: 3em; height: 3em; background-color: #f8f8f6;"/></a></div></div>`;
}
class EventService {
  events = [];
  static events = [];
  constructor() {
    this.events = events;
  }
  getAllEvents() {
    return this.events;
  }
  static getAllEvents(eventId) {
    return events;
  }
  getUpcomingEvents() {
    const currentDateTime = /* @__PURE__ */ new Date();
    return this.events.filter((event) => {
      const eventEnd = new Date(event.eventEnd);
      return eventEnd >= currentDateTime;
    }).sort((a, b) => {
      const aStart = new Date(a.eventStart);
      const bStart = new Date(b.eventStart);
      return aStart.getTime() - bStart.getTime();
    });
  }
  static getUpcomingEvents() {
    this.events = events;
    const currentDateString = (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
      timeZone: "America/Los_Angeles"
    });
    const currentDate = new Date(currentDateString);
    return this.events.filter((event) => {
      const eventEndDate = new Date(event.tmpEventEndDate);
      return eventEndDate >= currentDate;
    }).sort((a, b) => {
      const aStartDate = new Date(a.tmpEventStartDate);
      const bStartDate = new Date(b.tmpEventStartDate);
      return aStartDate.getTime() - bStartDate.getTime();
    });
  }
  getEventById(eventId) {
    const event = this.events.find((e) => e.eventId === eventId);
    return event ? event : void 0;
  }
  static getEventById(eventId) {
    this.events = events;
    const event = this.events.find((e) => e.eventId === eventId);
    return event ? event : void 0;
  }
}
function UpcomingEvents($$payload, $$props) {
  push();
  const eventService = new EventService();
  const upcomingEvents = eventService.getUpcomingEvents();
  const getCardColor = (event) => {
    if (event.eventSeriesKey == "rosedale-fair" || event.eventSeriesKey == "downtown-fair") {
      return "#d6b99a";
    } else if (event.eventSeriesKey == "night-fair") {
      return "#9ab7d6";
    } else if (event.eventSeriesKey == "riverwalk-fair") {
      if (event.dayOfTheWeek === "Friday") {
        return "#9ab7d6";
      }
      return "#9ad6b9";
    } else {
      return "#ffffff";
    }
  };
  $$payload.out += `<div class="upcoming-events-container w-full flex flex-col items-center">`;
  if (upcomingEvents.length === 0) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<p class="no-events-message">No upcoming events.</p>`;
  } else {
    $$payload.out += "<!--[!-->";
    const each_array = ensure_array_like(upcomingEvents);
    $$payload.out += `<div class="lg:w-full md:w-full sm:w-full xs:w-full flex flex-col items-center"><div class="text-center">`;
    Heading($$payload, {
      tag: "h1",
      class: "mb-4 text-4xl font-extrabold xs:text-4xl sm:text-4xl md:text-4xl lg:text-4xl p-6",
      style: "font-family: 'Georgia', serif; height: 7rem;",
      children: ($$payload2) => {
        $$payload2.out += `<!---->Upcoming Events`;
      },
      $$slots: { default: true }
    });
    $$payload.out += `<!----></div> <!--[-->`;
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let event = each_array[$$index];
      Card($$payload, {
        href: "/events?eventId=" + event.eventId.toLocaleString(),
        class: "upcoming-events-card-container p-10 max-w-xl",
        style: `background-color: ${stringify(getCardColor(event))}; font-family: 'Georgia', serif;`,
        children: ($$payload2) => {
          if (event.cancelled) {
            $$payload2.out += "<!--[-->";
            $$payload2.out += `<div class="cancelled-banner text-center mb-4 p-2 bg-red-600 text-white font-bold">CANCELLED</div>`;
          } else {
            $$payload2.out += "<!--[!-->";
          }
          $$payload2.out += `<!--]--> <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" style="font-family: 'Georgia', serif;">${escape_html(event.name)}</h5> <h5 class="mb-2 text-lg font-semibold tracking-tight text-gray-800 dark:text-gray-300" style="font-family: 'Georgia', serif;">${escape_html(event.tmpDisplayDate + " @" + event.tmpDisplayTime)}</h5> <p class="text-lg font-normal text-gray-700 dark:text-gray-400" style="font-family: 'Georgia', serif;">${escape_html(event.location)}</p> <p class="text-lg font-normal text-gray-700 dark:text-gray-400" style="font-family: 'Georgia', serif;">${escape_html(event.city + ", " + event.state)}</p>`;
        },
        $$slots: { default: true }
      });
      $$payload.out += `<!----> <br/>`;
    }
    $$payload.out += `<!--]--></div>`;
  }
  $$payload.out += `<!--]--></div>`;
  pop();
}
export {
  SocialMediaIcons as S,
  UpcomingEvents as U
};
